module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "font-size-control list-group w-100",
    class: {
      'rounded-0': !_vm.multiple,
      'subtitles': !_vm.multiple
    }
  }, _vm._l((_vm.texts), function(text, idx) {
    return (_vm.multiple || _vm.isSentActived(text)) ? _c('li', {
      key: idx,
      class: {
        'list-group-item': true,
        'active': _vm.multiple && _vm.isSentActived(text),
          'text-center': !_vm.multiple,
          'text-left': _vm.multiple,
          'd-flex': _vm.multiple
      }
    }, [(_vm.hasLeftSideSlot) ? _c('div', [_vm._t("leftside", null, {
      "row": text
    })], 2) : _vm._e(), _vm._v(" "), (_vm.lang.indexOf('en_us') > -1) ? _c('div', {
      staticClass: "english mx-auto w-100",
      on: {
        "click": function($event) {
          return _vm.$emit('selectSentId', idx, text.Text)
        }
      }
    }, [(_vm.multiple && text.name) ? _c('span', {
      staticClass: "role-name pl-3",
      domProps: {
        "innerHTML": _vm._s(text.name + ': ')
      }
    }) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('p', {
      staticClass: "pl-5",
      domProps: {
        "innerHTML": _vm._s(_vm.isContains(text, _vm.highlight))
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.multiple) ? _c('p', {
      staticClass: "subtitle-single",
      domProps: {
        "innerHTML": _vm._s(_vm.isContains(text, _vm.highlight))
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.lang.indexOf('zh_tw') > -1) ? _c('div', {
      staticClass: "mx-auto w-100",
      on: {
        "click": function($event) {
          return _vm.$emit('selectSentId', idx, text.text)
        }
      }
    }, [(_vm.multiple && Array.isArray(text.name_i18N) && text.name_i18N[text.name_i18N.map(function (e) {
      return e.language
    }).indexOf('Zh')].value !== '') ? _c('span', {
      staticClass: "pl-3"
    }, [_vm._v("\n        " + _vm._s(text.name_i18N[text.name_i18N.map(function (e) {
      return e.language
    }).indexOf('Zh')].value + ': ') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('p', {
      staticClass: "pl-5"
    }, [_vm._v(_vm._s(text.text_i18N[text.text_i18N.map(function (e) {
      return e.language
    }).indexOf('Zh')].value))]) : _vm._e(), _vm._v(" "), (!_vm.multiple) ? _c('p', {
      staticClass: "subtitle-single"
    }, [_vm._v("\n        " + _vm._s(text.text_i18N[text.text_i18N.map(function (e) {
      return e.language
    }).indexOf('Zh')].value) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dict && text.dicInfos) ? _c('div', {
      staticClass: "mx-auto w-100"
    }, [(text.name) ? _c('span', {
      staticClass: "role-name pl-3"
    }, [_vm._v(_vm._s(text.name + ': '))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "pl-5"
    }, _vm._l((text.dicInfos), function(word, index) {
      return _c('span', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.$emit('word', word.key)
          }
        }
      }, [_vm._v(_vm._s(word.word + ' '))])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.hasRightSideSlot) ? _c('div', [_vm._t("rightside", null, {
      "row": text
    })], 2) : _vm._e()]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-408eaf25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/Sentences.vue
// module id = 777
// module chunks = 3